import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { ILabelCustomer } from '@/features/settings/label/label-customer/types/label-customer.type';

export const assignLabelCustomerValidationSchema = z.object({
  customerId: z.string().min(1),
  labelIds: z.array(z.string().min(1)).min(1),
});

export type TAssignLabelCustomerValidation = z.infer<typeof assignLabelCustomerValidationSchema>;
export type TAssignLabelCustomerResponse = ApiResponse<ILabelCustomer>;

export const assignLabelCustomer = async (
  data: TAssignLabelCustomerValidation
): Promise<TAssignLabelCustomerResponse> => {
  const url = `/customer-management/label/${data?.customerId}`;

  const dataRequest = {
    labelIds: data?.labelIds,
  };

  return axiosInstance.patch(url, dataRequest);
};

type UseAssignLabelCustomerMutationOptions<TContext = unknown> = {
  mutationConfigOptions?: TypedMutationConfig<typeof assignLabelCustomer, AxiosErrorCustom, TContext>;
};

export const useAssignLabelCustomerMutation = <TContext = unknown>({
  mutationConfigOptions,
}: UseAssignLabelCustomerMutationOptions<TContext>) => {
  const { ...rest } = mutationConfigOptions || {};

  return useMutation({
    mutationFn: assignLabelCustomer,
    ...rest,
  });
};
